import { render } from "./TenantBillingCard.vue?vue&type=template&id=0de2a2e5&scoped=true&ts=true"
import script from "./TenantBillingCard.vue?vue&type=script&lang=ts"
export * from "./TenantBillingCard.vue?vue&type=script&lang=ts"

import "./TenantBillingCard.vue?vue&type=style&index=0&id=0de2a2e5&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de2a2e5"]])

export default __exports__